import List from "@/components/list";
import Bus from "./Bus.js";
import { getItem } from "@/utils/storage";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete({ row }) {
    Bus.$emit("deleteRole", row);
  }
  function handleUpdate({ row }) {
    Bus.$emit("handleUpdate", Object.assign({}, row));
  }
  // function getMenuID({ row }) {
  //   Bus.$emit("getMenuID", row);
  // }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      // ["icon-edit", "编辑", () => handleUpdate(vo), ""],
      // ["icon-delete", "删除", () => handleDelete(vo), ""]
      // ["授权", () => getMenuID(vo), ""]
    ];
    // v-permission={item[2]}
    // 不是超级管理员 && deptId为空则不可编辑
    if (getItem("userType") !== -1 && vo.row.deptId == args.props.parentId) {
      dealConf.push(
        [
          "icon-edit-disable",
          "编辑",
          () => {
            return;
          },
          "role:update"
        ],
        [
          "icon-delete-disable",
          "删除",
          () => {
            return;
          },
          "role:delete"
        ]
      );
    } else {
      dealConf.push(
        ["icon-edit", "编辑", () => handleUpdate(vo), "role:update"],
        ["icon-delete", "删除", () => handleDelete(vo), "role:delete"]
      );
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main"
    // },
    // {
    //   label: "角色编号",
    //   prop: "uuid",
    //   minWidth: "100"
    // },
    {
      label: "角色名称",
      prop: "roleName",
      minWidth: "140",
      showOverflowTooltip: true
    },
    {
      label: "角色描述",
      prop: "roleDesc",
      minWidth: "140",
      showOverflowTooltip: true
    },
    {
      label: "用户数",
      prop: "num",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "所属学院",
      prop: "deptName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "150"
    },
    {
      label: "操作",
      minWidth: "130",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
